import { Diffuseur } from '../../../models/diffuseur';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Endpoints } from '../../../models/endpoints';
import { SessionService } from '../../administration/services/session.service';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class PresseSpecialiseService {

  constructor(private http: HttpService, private session: SessionService) {
  }

  public createPresse(presse: Diffuseur): Observable<Diffuseur> {

    const body = presse;
    return this.http.post(
      Endpoints.PRESSE
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      + Endpoints.PREFERENCE_RAISON_SOCIALE
      + this.session.getUser()?.raisonSociale
      , body
      , Diffuseur
    );
  }

  public updatePresse(presse: Diffuseur): Observable<Diffuseur> {
    const body = presse;
    return this.http.put(
      Endpoints.PRESSE
      , body
      , Diffuseur
    );
  }

  public getAllPresse(): Observable<Diffuseur[]> {
    return this.http.get<Diffuseur[], Diffuseur>(
      Endpoints.PRESSE
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      , Diffuseur
    );
  }

  public getByIdPresse(id: number): Observable<Diffuseur> {
    return this.http.get(
      Endpoints.PRESSE
      + '/' + id
      , Diffuseur
    );
  }

  public deletePresse(id: number): Observable<any> {
    return this.http.delete(
      Endpoints.PRESSE
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      + Endpoints.PREFERENCE_AND_ID
      + id
    );
  }
}
